// extracted by mini-css-extract-plugin
export var brand = "_4x-9";
export var compact = "_4x-6";
export var extraSmall = "_4x-7";
export var icon = "_4x-0";
export var large = "_4x-4";
export var light = "_4x-1";
export var medium = "_4x-5";
export var outline = "_4x-b";
export var primaryDark = "_4x-a";
export var primaryLight = "_4x-8";
export var primaryModern = "_4x-c";
export var success = "_4x-2";
export var successSolid = "_4x-3";